module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-button', {
    class: _vm.buttonClass,
    attrs: {
      "disabled": _vm.isExporting || _vm.disabled,
      "size": _vm.size,
      "variant": _vm.variant
    },
    on: {
      "click": _vm.handleExport
    }
  }, [(_vm.isExporting) ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Exporting..."
    }
  }) : _vm._e(), _vm._v("\n    " + _vm._s(_vm.displayText) + "\n  ")], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a79dab3","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/common/ExcelExportButton.vue
// module id = 2481
// module chunks = 0